import { Injectable } from '@angular/core';
import { ReportServiceApiService } from './report-service-api.service';
import { ViewNameDto } from './dto/view-name.dto';
import { ColumnDefinitionDto } from './dto/column-definition.dto';
import { QueryDefinitionDto } from './dto/query-definition.dto';
import { DataQueryDto } from './dto/data-query.dto';
import { HttpBackend, HttpClient, HttpHandler, HttpRequest, HttpXhrBackend } from '@angular/common/http';
import { HttpRequestService, PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { HttpRequestOptions } from 'src/app/shared/http/http-request-options.model';
import { QueryResultDto } from './dto/query-result.dto';
import { DataDictionaryTableDto } from './dto/data-dictionary-table.dto';
import { DataDictionaryTableColumnDto } from './dto/data-dictionary-table-column.dto';
import { DuplicateCheckDto } from './dto/duplicate-check-dto';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private _apiService: ReportServiceApiService, private _httpService: HttpRequestService, private httpBackend: HttpBackend) {}

  // api calls go here
  getViews(): Promise<Array<ViewNameDto>> {
    return this._httpService.get('https://s3.us-east-2.amazonaws.com/atlas.unrestricted/view-info/Views.json', {
      Headers: [{ name: 'Annonymous', value: '' }],
    } as HttpRequestOptions);
  }

  getFields(viewName: string): Promise<Array<ColumnDefinitionDto>> {
    const httpClient = new HttpClient(this.httpBackend);
    return this._httpService
      .get(`https://s3.us-east-2.amazonaws.com/atlas.unrestricted/view-info/views/${viewName}.json`, {
        Headers: [{ name: 'Annonymous', value: '' }],
      } as HttpRequestOptions)
      .then((data) => {
        return data
          .filter((x) => !!!x.Hide)
          .sort((a, b) => {
            if (a.ReplacementName > b.ReplacementName) {
              return 1;
            }

            if (a.ReplacementName < b.ReplacementName) {
              return -1;
            }

            return 0;
          });
      });
  }

  runQuery(dataQuery: DataQueryDto): Promise<QueryResultDto> {
    return this._apiService.post('report/v2/dataquery/runQuery', dataQuery);
  }

  createDataQuery(dataQueryDto: DataQueryDto): Promise<void> {
    return this._apiService.post(`report/v2/dataquery`, dataQueryDto);
  }

  updateDataQuery(dataQueryDto: DataQueryDto): Promise<void> {
    return this._apiService.put(`report/v2/dataquery`, dataQueryDto);
  }

  duplicateQueryCheck(data: DuplicateCheckDto): Promise<number> {
    return this._apiService.post(`report/v2/dataquery/duplicateNameCheck`, data);
  }

  getDataQuery(id: number): Promise<DataQueryDto> {
    return this._apiService.get(`report/v2/dataquery/${id}`);
  }

  exportDataQuery(dataQueryDto: DataQueryDto): Promise<string> {
    return this._apiService.post(`report/v2/dataquery/export`, dataQueryDto);
  }

  exportDataQueryWithId(id: number): Promise<string> {
    return this._apiService.get(`report/v2/dataquery/${id}/export`);
  }
  exportDataQueryWithDates(dataQuery: DataQueryDto): Promise<string> {
    return this._apiService.post(`report/v2/dataquery/${dataQuery.Id}/export/dateparams`, dataQuery.DateParameters);
  }
  getDataQueryProfileIds(dataQueryDto: DataQueryDto): Promise<Array<number>> {
    return this._apiService.post(`report/v2/dataquery/profileids`, dataQueryDto);
  }

  getDataQueryProfileIdsWithId(id: number): Promise<Array<number>> {
    return this._apiService.get(`report/v2/dataquery/${id}/profileids`);
  }
  getQueryProfileIdsWithDates(dataQuery: DataQueryDto): Promise<number[]> {
    return this._apiService.post(`report/v2/dataquery/${dataQuery.Id}/profileids/dateparams`, dataQuery.DateParameters);
  }
  deleteQuery(id: number): Promise<void> {
    return this._apiService.delete(`report/v2/dataquery/${id}`);
  }

  getQueries(searchParams: PagedSearch): Promise<PagedResultGeneric<DataQueryDto>> {
    return this._apiService.post(`report/v2/dataqueries`, searchParams);
  }

  getDbTableList(): Promise<DataDictionaryTableDto[]> {
    return this._apiService.get(`report/v2/datadictionary/table-list`);
  }

  getDbTableColumns(objectIds: number[]): Promise<DataDictionaryTableColumnDto[]> {
    return this._apiService.post(`report/v2/datadictionary/table/column-list`, objectIds);
  }
}
